<clr-dropdown [clrCloseMenuOnItemClick]="true">
  <input
    clrDropdownTrigger
    aria-label="Dropdown demo button"
    id="search_input"
    type="text"
    class="prompt"
    placeholder="Suche nach Firmenname..."

    (keyup)="onKeyUp($event)" />
  <cds-icon shape="angle" direction="down"></cds-icon> (mind. drei Zeichen eingeben)
  <clr-dropdown-menu *clrIfOpen>
    <div *ngFor="let companies of foundCompanies; index as i" clrDropdownItem (click)="chooseSupplier(i, companies)">{{ companies.cid }} - {{ companies.company }}
      <span *ngIf="companies.department"> - {{ companies.department }}</span>
      <span *ngIf="companies.classification"> - {{ companies.classification }}</span>
    </div>
  </clr-dropdown-menu>
</clr-dropdown>
